var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssuePriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9744 0C5.37313 0 0 5.37313 0 12.0256C0 12.2303 0 12.4861 0 12.6908H6.7548L9.82516 2.2516L12.5885 14.4819L14.8401 8.08529L17.1429 12.6908H24C24 12.4861 24 12.2303 24 12.0256C24 5.37313 18.6269 0 11.9744 0ZM15.1471 12.6397L12.2303 21.032L9.62047 9.3646L8.08529 14.4819H0.255864C1.38166 19.9062 6.1919 24 11.9744 24C17.7569 24 22.6183 19.9062 23.7441 14.4819H16.0682L15.1471 12.6397Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuePriority);
export default __webpack_public_path__ + "static/media/issue-priority.971bb1ffc5782245cebe7a9beae28b5c.svg";
export { ForwardRef as ReactComponent };